import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { fromAppointmentTypeQueryToAppointmentType } from '../../adapters/from-appointment-type-query-to-appointment-type.js';
import { GET_BOOK_APPOINTMENT_TYPE } from '../../queries/get-book-appointment-type.js';

const useBookAppointmentType = ()=>{
    const [query, queryState] = useLazyQuery(GET_BOOK_APPOINTMENT_TYPE);
    const { locale  } = useIntl();
    if (queryState.error) {
        console.error(queryState.error);
    }
    const getBookAppointmentType = React.useCallback((id)=>query(swcHelpers.objectSpread({
            variables: {
                id
            }
        }, locale ? {
            context: {
                forwardHeaders: {
                    'Accept-Language': locale
                }
            }
        } : {}))
    , [
        query,
        locale
    ]);
    const data = React.useMemo(()=>{
        var ref;
        return fromAppointmentTypeQueryToAppointmentType((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.appointmentType);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            getBookAppointmentType,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getBookAppointmentType,
        queryState,
        data
    ]);
};
var useBookAppointmentType$1 = useBookAppointmentType;

export { useBookAppointmentType$1 as default };
//# sourceMappingURL=use-book-appointment-type.js.map
